import { render, staticRenderFns } from "./Dialog_ChangeClassPlan.vue?vue&type=template&id=40d61c6e&scoped=true&"
import script from "./Dialog_ChangeClassPlan.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChangeClassPlan.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_ChangeClassPlan.vue?vue&type=style&index=0&id=40d61c6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d61c6e",
  null
  
)

export default component.exports